import React from 'react';
import { Redirect } from '../../../../Router';
import { routes } from '../../routes';

const RedirectToTimeTracking: React.FC = () => (
  <Redirect to={routes.timeTracking.route} />
);

export default RedirectToTimeTracking;
